// ============================================================================
// INSIGHTS — article system. `published: false` articles are NOT indexed and
// only appear as clearly-marked drafts (hidden in production listing).
// Add real article body content here as it is written. Do not fabricate.
// ============================================================================

export const insightCategories = [
  "Local Visibility",
  "Lead Generation",
  "Customer Follow-Up",
  "Reviews and Referrals",
  "Automation and AI",
  "Business Growth",
];

export const articles = [
  {
    slug: "why-good-trade-businesses-lose-ready-leads",
    title: "Why good trade businesses still lose ready-to-buy leads",
    category: "Lead Generation",
    excerpt:
      "Being found is only half the job. Here is where ready customers slip away between the enquiry and the booking—and what a connected system does differently.",
    published: true,
    date: "2025-11-02",
    readMinutes: 5,
    body: [
      "Most trade businesses do not have a visibility problem alone. They have a continuity problem. A customer finds you, calls or fills in a form, and then the moment stalls—because the team is on the tools and nobody is watching the pipeline.",
      "A ready-to-buy lead rarely waits. If the call is missed and there is no text-back, or the quote goes out and follow-up never happens, the customer simply rings the next business. The enquiry was never the problem. The response was.",
      "A connected growth system treats the enquiry as the start of a process, not the finish line. Calls and forms land in one place. Missed calls trigger a message. Quotes have a follow-up rhythm. Nothing depends on the owner remembering at 9pm.",
      "The practical takeaway: before spending more on advertising, make sure every enquiry you already generate is captured, answered and followed up consistently. That is usually where the fastest gains hide.",
    ],
  },
  {
    slug: "improve-google-business-profile-local-trade",
    title: "How to improve your Google Business Profile as a local trade",
    category: "Local Visibility",
    excerpt:
      "Your Google Business Profile is often the first impression a local customer gets. A few consistent habits make it work much harder for you.",
    published: true,
    date: "2025-11-10",
    readMinutes: 6,
    body: [
      "For most trade businesses, the Google Business Profile is doing more work than the website. It is where local customers compare options, read reviews and decide who to call.",
      "Start with the basics done properly: accurate services, service areas, hours, and clear, real photos of your work and team. Consistency across your listings matters more than most owners expect.",
      "Reviews are the engine. A simple, respectful system for asking every satisfied customer—and responding to what comes back—builds the credibility that wins the next enquiry.",
      "Treat the profile as something you maintain, not something you set once. Regular updates and steady reviews keep it credible and visible over time.",
    ],
  },
  {
    slug: "what-happens-after-a-lead-arrives",
    title: "What happens after a lead arrives matters as much as the advertisement",
    category: "Customer Follow-Up",
    excerpt:
      "Ad spend gets attention. Response and follow-up turn that attention into booked work. Here is why the second half deserves equal focus.",
    published: false,
    date: "2025-11-18",
    readMinutes: 4,
    body: [
      "This is a draft article and is not yet published.",
    ],
  },
];

export const getArticle = (slug) => articles.find((a) => a.slug === slug);
export const publishedArticles = articles.filter((a) => a.published);
